import { useContext } from "react";
import { RootPath } from "../../context/root_path";
import { routeFactory } from "../../routes/route_factory";

export function useRoutes() {
    const path = useContext(RootPath);
    const routes = routeFactory(path);
    return routes;
}
